<template>
    <v-col cols="12" class="py-0">
        <v-chip v-for="(item, index) in items" :key="index" class="mr-2 mt-2">
            {{ item }}
        </v-chip>
    </v-col>
</template>
<script>
export default {
    props: {
        items: Array,
    },
};
</script>